import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import {useGetUserQuery, useCreatePaymentMutation, useGetPaymentsQuery} from "../services/endpoints/user.api";
// import logo from "../assets/media/logo_pay.png";
// import { QRCodeCanvas } from 'qrcode.react';  // Importa il componente QRCode
import Logo from './base/LogoComponent';
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import './Login.css'
import {useLoginMutation, useLazyMeQuery,useMeQuery} from "../services/endpoints/user.api";
import { useDispatch } from "react-redux";
import { updateAccessToken } from "../services/userAuthSlice";
import {skipToken} from "@reduxjs/toolkit/query";
const Login = () => {
    const dispatch = useDispatch();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione
    const [login, { isLoading }] = useLoginMutation(); // Hook RTK
    const [errorMessage, setErrorMessage] = useState(null); // <-- errore locale
    const {data:meData, isLoading: isMeLoading, isSuccess } = useMeQuery();
    const [me, { isMeeLoading }] =  useLazyMeQuery() // Hook RTK

    // Redirigi se è autenticato
    useEffect(() => {
        if (!isMeLoading && isSuccess) {
            console.log(meData)
            if(meData.data.roles.includes('admin')) {
                navigate('/profile-admin')
            } else

            if(meData.data.roles.includes('leader')) {
                navigate('/profile-operator')
            }
            else
                navigate("/profile");
        }
    }, [isSuccess, isMeLoading, navigate]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const result = await login({ username, password }).unwrap();
            // Se va tutto bene, redirigi
            localStorage.setItem("token", result.token);
            localStorage.setItem("userId", result.userId);
            dispatch(updateAccessToken({ token: result.token, userId: result.userId }));
            console.log("Login riuscito – Redux aggiornato:", result.token, result.userId);

            setErrorMessage(null); // reset in caso di successo

            const user = await me()
            if(user.data.data.roles.includes('admin')) {
                navigate('/profile-admin')
            } else

            if(user.data.data.roles.includes('leader')) {
                navigate('/profile-operator')
            }
             else
            navigate("/profile");
        } catch (err) {
            console.error("Login error", err);
            if(err.status === 401) {
                setErrorMessage("Username o password errati.");
            } else {
                setErrorMessage("Errore durante il login. Riprova.");
            }
        }
    };
    if (isMeLoading) return <div className="text-center mt-5">Verifica sessione in corso...</div>;

    return (
        <div>
            <Header/>
            <main className="container form-signin w-50 pt-5 m-sm-auto text-center">
                <form onSubmit={handleSubmit}>
                    {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    <div className="form-floating mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="floatingInput"
                            placeholder="name@example.com"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <label htmlFor="floatingInput">Username</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            type="password"
                            className="form-control"
                            id="floatingPassword"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <label htmlFor="floatingPassword">Password</label>
                    </div>

                    <div className="form-check text-start my-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="remember-me"
                            id="checkDefault"
                        />
                        <label className="form-check-label" htmlFor="checkDefault">
                            Ricordami
                        </label>
                    </div>

                    <button className="btn btn-primary w-100 py-2" type="submit" disabled={isLoading}>
                        {isLoading ? "Caricamento..." : "Entra"}
                    </button>
                    <p className="mt-5 mb-3 text-body-secondary"><a href="/reset-password">Hai dimenticato la password?</a></p>
                    <p className="mt-5 mb-3 text-body-secondary">Se non sei registrato puoi farlo <a href="/registration">qui!</a></p>
                    <p className="mt-5 mb-3 text-body-secondary">CiSono© {new Date().getFullYear() }</p>
                </form>
            </main>
            <Footer />
        </div>
    );

};

export default Login;
